import { useRouter, useRoute } from 'vue-router'
import { EventBus } from '@/event-bus/event-bus'

const useEventActions = () => {
  const route = useRoute()
  const router = useRouter()

  const changeSelectedEvent = async (eventId) => {
    try {
      EventBus.$emit('enable-connection-targets', false)
      if (eventId) {
        await router.push({ path: '/workflow/' + route.params.projectId + '/' + route.params.id + '/' + eventId })

        const focusedElement = document.activeElement

        if (!!focusedElement?.id && focusedElement.id !== eventId) {
          focusedElement.blur()
        }
      } else {
        await router.push({ path: '/workflow/' + route.params.projectId + '/' + route.params.id })
      }
    } catch (e) {}
  }

  return { changeSelectedEvent }
}

export default useEventActions
